function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "md-heart-empty");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Courses/Cart-Course",
  transform: "translate(-716.000000, -41.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "md-heart-empty",
  transform: "translate(716.000000, 41.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.85416667,0 C6.90625,0 6.01302083,0.434895833 5.41666667,1.14322917 C4.8203125,0.434895833 3.92708333,0 2.97916667,0 C1.29947917,0 0,1.30729167 0,2.99739583 C0,5.06770833 1.84114583,6.72916667 4.63020833,9.29166667 L5.41666667,10 L6.203125,9.29166667 C8.9921875,6.72916667 10.8333333,5.06770833 10.8333333,2.99739583 C10.8333333,1.30729167 9.53385417,0 7.85416667,0 Z M5.75,8.57552083 L5.640625,8.67708333 L5.41666667,8.88020833 L5.19270833,8.67708333 L5.08333333,8.57552083 C3.77083333,7.36979167 2.63541667,6.328125 1.88802083,5.3984375 C1.15885417,4.49479167 0.8359375,3.75520833 0.8359375,2.99739583 C0.8359375,2.40104167 1.0546875,1.85416667 1.453125,1.453125 C1.84895833,1.05208333 2.390625,0.833333333 2.97916667,0.833333333 C3.65885417,0.833333333 4.33333333,1.15104167 4.77864583,1.6796875 L5.41666667,2.4375 L6.0546875,1.6796875 C6.5,1.1484375 7.17447917,0.833333333 7.85416667,0.833333333 C8.44270833,0.833333333 8.984375,1.05208333 9.3828125,1.453125 C9.78125,1.85416667 10,2.40364583 10,2.99739583 C10,3.75260417 9.67447917,4.49479167 8.94791667,5.3984375 C8.19791667,6.328125 7.06510417,7.36979167 5.75,8.57552083 Z",
  id: "Shape"
}))));

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 11 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.a9f0e6a8.svg";
export { ForwardRef as ReactComponent };